import { MRT_ColumnDef } from "material-react-table";
import { useMemo } from "react";
import { Contrato } from "../interfaces";

export const useTableColumnsContrato = () => {



  const columnsContrato = useMemo<MRT_ColumnDef<Contrato>[]>(
    () => [
      {
        accessorKey: 'cliente_data.identificacion',
        header: 'identificación',
      },
      {
        accessorKey: 'cliente_data.razon_social',
        header: 'Razón Social',
      },

    ],
    [],
  );

  return {
    columnsContrato,
  }
}